import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const Wrapper = styled.div`
  font-size: ${({ size }) => size}em;
  height: 1em;
  width: 1em;
  position: relative;
  &:before {
    position: absolute;
    width: 100%;
    height: 100%;
    content: "";
    border: 0.16em solid ${({ theme }) => theme.palette.darker};
    border-radius: 50%;
    box-sizing: border-box;
  }
  svg {
    position: relative;
    fill: transparent;
    stroke: ${({ theme }) => theme.palette.blue.light};
    stroke-width: 16;
    stroke-dasharray: 263;
    stroke-dashoffset: ${({ perc }) => 263 - (263 * perc) / 100};
    /* stroke-linecap: round; */
    transform-origin: 50% 50%;
    transform: rotate(-90deg);
  }
`;

const ProgressCircle = ({ className, perc, size }) => {
  const classes = ["ProgressCircle"];
  if (className) classes.push(className);

  return (
    <Wrapper className={classes.join(" ")} perc={perc} size={size}>
      <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
        <circle cx="50" cy="50" r="42" />
      </svg>
    </Wrapper>
  );
};

ProgressCircle.displayName = "ProgressCircle";

ProgressCircle.propTypes = {
  className: PropTypes.string,
  perc: PropTypes.number.isRequired,
  size: PropTypes.number,
};

ProgressCircle.defaultProps = {
  className: null,
  size: 1,
};

export default ProgressCircle;
